import * as React from 'react';
import type { SVGProps } from 'react';
const SvgJpegToPdf24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#F4AC3F" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.178 18.667h.75c.72 0 1.08 0 1.278-.15a.74.74 0 0 0 .293-.547c.015-.248-.185-.547-.584-1.146l-2.233-3.345c-.33-.494-.496-.742-.704-.828a.74.74 0 0 0-.568 0c-.208.086-.373.334-.703.828l-.552.827m3.023 4.36-5.7-8.221c-.328-.473-.492-.71-.697-.793a.74.74 0 0 0-.559 0c-.204.083-.368.32-.696.793l-4.41 6.362c-.419.602-.627.903-.616 1.154a.74.74 0 0 0 .29.553c.2.153.567.153 1.3.153zm1.483-11.11a2.224 2.224 0 0 1-2.225 2.222 2.224 2.224 0 0 1-2.225-2.223c0-1.227.996-2.222 2.225-2.222s2.225.995 2.225 2.222"
    />
  </svg>
);
export default SvgJpegToPdf24;
